import React, { useEffect, useState, useRef } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import OverlayedLayout from "./Layouts/Overlayed";
import TwoColumnLayout from "./Layouts/TwoColumn";
import TwoColumnGridLayout from "./Layouts/TwoColumnGrid";
import "./TextWithMedia.scss";

const layouts = {
  "2column": TwoColumnLayout
};

export const TextWithMedia = ({settings, blocks, props}) =>
{
    const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    let Layout = layouts[settings.layout_type || '2column'] || TwoColumnLayout;
    const contentRef: any = useRef(null); // Ref to measure the content height

    if (isMobile) {
        Layout = layouts[settings.layout_type_mobile] || TwoColumnLayout;
    }

    if (settings.render_type !== "all") {
        if (isMobile && settings.render_type !== "mobile-only") return null;
        if (!isMobile && settings.render_type !== "desktop-only") return null;
    }

    return (
      <div
          className={`${settings.reveal_animation_class} relative`}
          style={{
            paddingTop: `${settings.padding_top}px`,
            paddingBottom: `${settings.padding_bottom}px`
          }}>
      <div
            ref={contentRef}
            className={`relative w-full h-full justify-end items-end`}
        >
            <Layout
              blocks={blocks}
              settings={settings}
              props={props}
          />
        </div>
      </div>
  );
};
